<template>
  <div>
    <Modal @closeModal="$emit('closeTriggered')" modal_style="modal-small">
      <!-- MODAL TITLE -->
      <div slot="modal-title">
        <span class="form-title font-weight-bold">Reject Exam</span>
      </div>

      <!-- MODAL BODY -->
      <div slot="modal-body">
        <div class="exam-modal-body">
          <div
            v-if="show_feedback"
            class="feedback-block"
            :class="feedback_type === 'success' ? 'success-bg' : 'error-bg'"
          >
            {{ feedback_message }}
          </div>

          <!-- EXAM INFO -->
          <div class="exam-info">
            <div class="avatar">
              <img v-lazy="localImg('Exam.png')" alt="" />
            </div>

            <div class="wrapper">
              <div class="top-text color_text font-weight-700">
                {{ exam_info.title }}
              </div>

              <div class="bottom-text">
                <span class="mr-1">{{ exam_info.class_name }}</span> •
                <span class="mx-1"
                  >{{ exam_info.question_count }} Questions</span
                >
                •
                <span class="ml-1">{{ exam_info.score }} Points</span>
              </div>
            </div>
          </div>

          <!-- INFO TEXT  -->
          <div class="info-text color_text font-weight-700" v-if="false">
            Why are you rejecting this examination?
          </div>

          <div class="form-area" v-if="false">
            <textarea
              class="form-control"
              rows="6"
              placeholder="Please drop a comment on what you’d like the teacher to change in this questions"
            ></textarea>
          </div>

          <!-- BUTTON ROW -->
          <div class="btn-row font-weight-700">
            <button
              class="btn bg-transparent z-depth-0 brand_navy mr-2"
              @click="$emit('closeTriggered')"
            >
              Cancel
            </button>
            <button class="btn btn-accent mx-0" @click="rejectExam">
              <span v-if="!approving">Reject Questions</span>
              <span
                v-if="approving"
                class="icon icon-dotted-spinner animate mr-2"
              ></span>
              <span v-if="approving" class="">Rejecting</span>
            </button>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Modal from "@/components/globalComps/Modal";

export default {
  name: "ExamRejectModal",

  components: {
    Modal,
  },

  props: {
    exam_info: Object,
  },

  computed: {
    rejectionPayload() {
      return {
        status: {
          status: 0,
          open_date: this.exam_info.open_date,
          close_date: this.exam_info.close_date,
          can_start: 1,
          can_see_score: 1,
          can_see_answer: 1,
        },
        exam_id: this.exam_info.id,
      };
    },
  },

  data() {
    return {
      show_feedback: false,
      feedback_type: "",
      feedback_message: "",
      approving: false,
    };
  },

  mounted() {
    console.log(this.exam_info);
  },

  methods: {
    ...mapActions(["approveOrDeclineExam"]),

    showFeedback(type, message, delay = 800) {
      this.feedback_type = type;
      this.show_feedback = true;
      this.feedback_message = message;

      setTimeout(() => {
        this.clearFeedback();
        if (type === "success") this.$router.push({ name: "SchoolDashboard" });
      }, delay);
    },

    clearFeedback() {
      this.feedback_type = "";
      this.feedback_message = "";
      this.show_feedback = false;
    },

    rejectExam() {
      this.approving = true;

      this.approveOrDeclineExam(this.rejectionPayload)
        .then(({ code }) => {
          this.approving = false;
          if (code === 200) {
            this.showFeedback("success", "Exam successfully rejected");
          } else this.showFeedback("error", "Failed to reject Exam", 1200);
        })
        .catch((err) => {
          console.log("error rejecting this exam", err);
          this.approving = false;
          this.showFeedback("error", "Error rejecting Exam", 1200);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.form-title {
  font-size: 16px;
}

.exam-modal-body {
  .exam-info {
    @include flex_row_start_nowrap;
    margin-bottom: 23px;

    .avatar {
      margin-right: 15px;
      @include equal_min_edge(48);
      border-radius: 10px;
      background: $brand_red_light;

      img {
        @include transform_center;
        @include equal_min_edge(25);
      }
    }

    .top-text {
      font-size: 15.5px;
      line-height: 22px;
      margin-bottom: 4.5px;
    }

    .bottom-text {
      font-size: 14px;
      line-height: 19px;
    }
  }

  .info-text {
    margin-bottom: 10px;
    font-size: 14px;
    line-height: 21px;
  }

  .form-area {
    @include flex_row_between_wrap;
    margin-bottom: 30px;

    .form-control {
      font-size: 13.5px;
      line-height: 22px;
    }
  }

  .btn-row {
    @include flex_row_end_nowrap;

    .btn {
      font-size: 11.5px;
      padding: 14px 32px !important;
    }
  }
}

.success-bg {
  border: 1px solid rgba(15, 168, 48, 0.5);
  background: rgba(rgb(108, 230, 169), 0.4);
  color: darken(rgb(6, 148, 82), 5%);
}

.error-bg {
  border: 1px solid lighten($brand_red, 15%);
  background: rgba($brand_red_light, 0.4);
  color: darken($brand_red, 5%);
}

.feedback-block {
  padding: 15px;
  border-radius: 10px;
  font-size: 0.85rem;
  text-align: center;
  margin-bottom: 25px;
}
</style>
